import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useUserMetadata = () => {
  const { user, isLoading: auth0Loading } = useAuth0();
  const [userMetadata, setUserMetadata] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setUserMetadata(null);

    if (auth0Loading) return;

    if (user && user['https://metadata.congruityhealth.com/user_metadata']) {
      setUserMetadata({
        Roles: user['https://metadata.congruityhealth.com/user_metadata'].Roles,
        App: user['https://metadata.congruityhealth.com/user_metadata'].App,
        User: user['https://metadata.congruityhealth.com/user_metadata'].User
      });
    } else {
      setUserMetadata(null);
    }
    setLoading(false);

  }, [user, auth0Loading]);

  return { userMetadata, user, loading };
};
